import { gql } from 'apollo-angular';

export const USER_FRAGMENT = {
  ALL_USER_INFO: gql`
    fragment AllUserInfo on SitePlayer {
      address {
        address
        city
        country
        id
        zipCode
        state
      }
      activeWallet: defaultWallet {
        amount: balance
        currency
        id
      }
      dob
      email
      emailConfirmed
      firstName
      gender
      id
      kyc
      language
      lastName
      phone
      status
      username
      phone
      phoneVerified
      receivePromo
      segments
      smsNotificationConsent
      emailNotificationConsent
    }
  `,
  MAIN_USER_INFO: gql`
    fragment MainUserInfo on SitePlayer {
      email
      firstName
      gender
      id
      language
      lastName
      phone
      status
      username
      phone
      segments
    }
  `,
  USER_ADDRESS: gql`
    fragment UserAddress on PlayerAddress {
      address
      city
      country
      id
      zipCode
      state
    }
  `,
  USER_PAYMENT_INFO: gql`
    fragment UserPaymentInfo on SitePlayer {
      activeWallet: defaultWallet {
        amount: balance
        currency
        id
      }
      walletsData: wallets {
        totalCount
        walletList: edges {
          node {
            amount: balance
            currency
            id
            bonusBalance
          }
        }
      }
    }
  `,
};

export const PAYMENT_FRAGMENT = {
  PAYMENT_METHOD_LIST: gql`
    fragment PaymentMethodList on SitePaymentMethod {
      alias
      methodType
      disabled
      strategyType
      preselected
      predefinedAmount
      minAmount
      maxAmount
      presetAmounts
      step
      savedAccountList: paymentDetails {
        paymentInfo
        paymentOptionId
      }
      requiredFields {
        defaultValue
        name
        inputType
        min
        max
        step
        placeholder
        regExp
        options {
          label
          value
        }
      }
    }
  `,
};

export const BONUS_FRAGMENT = {
  BONUS_ITEM: gql`
    fragment Bonus on SiteWalletBonus {
      id
      name
      activationExpiresAfter
      balance
      bonusId
      createdAt
      gameId
      issuedRounds
      status
      type
      updatedAt
      usageExpiresAfter
      usedRounds
      wagerAmount
      wagerMultiplier
      wageredAmount
    }
  `,
};

export const LOOTBOX_FRAGMENT = {
  LOOTBOX_ITEM: gql`
    fragment Lootbox on SiteLootbox {
      id
      title
      status
      issuedAt
      expiresAt
      items {
        weight
        title
      }
    }
  `,
};
